module.exports = __webpack_public_path__ + "static/media/Shield-plus.021add05.png";